export default __webpack_public_path__ + "static/media/lera.dc4a8c53.png";